import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, type FormInstance, Image, Modal } from 'antd';
import type { ProdutoAdicionalBody } from '@/features/produto-adicional/types/ProdutoAdicional';
import type { ProdutoAdicionalItemBody } from '@/features/produto-adicional/types/ProdutoAdicionalItem';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import { Container } from '@/components/Container';
import { PLACEHOLDER_IMAGE_PATH } from '@/std/const/placeholder-image-path';
import { numberToCurrency } from '@/std/format';
import { ProdutoTabAdicionalStatus } from './ProdutoTabAdicionalStatus';
import { removeAdicionalItemForm } from './util';

export function ProdutoTabAdicionalListItem({
    form,
    adicional,
    item,
    editarAdicionalItem,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    adicional: ProdutoAdicionalBody;
    item: ProdutoAdicionalItemBody;
    editarAdicionalItem: (adicional: ProdutoAdicionalBody, item: ProdutoAdicionalItemBody) => void;
    setFormDirty: (dirty: boolean) => void;
}) {
    return (
        <Container className='bg-white'>
            <Container.Content className='flex p-2'>
                <div className='flex w-full items-center gap-2'>
                    <div className='flex h-14 w-14 items-center justify-center'>
                        <Image
                            height={50}
                            src={item.pai_imagem || PLACEHOLDER_IMAGE_PATH}
                            width={50}
                        />
                    </div>

                    <div className='flex flex-1 flex-col'>
                        <div className='flex gap-1 text-base font-semibold'>
                            {item.pai_status && (
                                <ProdutoTabAdicionalStatus status={item.pai_status} />
                            )}
                            <div>{item.pai_nome}</div>
                        </div>

                        <div>{numberToCurrency(item.pai_valor_unitario)}</div>

                        <p className='text-sm text-gray-500 underline'>
                            {item.pai_aceita_multiplos === 'S' ? 'Múltiplos' : 'Único'}
                        </p>

                        {item.pai_detalhes ? (
                            <div className='text-sm text-gray-500'>{item.pai_detalhes}</div>
                        ) : null}
                    </div>

                    <div className='flex items-center justify-center gap-1'>
                        <Button
                            icon={<EditOutlined />}
                            onClick={() => editarAdicionalItem(adicional, item)}
                            size='small'
                        />

                        <Button
                            icon={<DeleteOutlined className='text-red-500' />}
                            onClick={() => {
                                Modal.confirm({
                                    content: `Deseja realmente excluir o adicional "${item.pai_nome}"?`,
                                    onOk: () => {
                                        removeAdicionalItemForm(form, adicional, item);
                                        setFormDirty(true);
                                    },
                                    title: 'Confirmar exclusão',
                                });
                            }}
                            size='small'
                        />
                    </div>
                </div>
            </Container.Content>
        </Container>
    );
}
